import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        parent: "public",
        path: "/dbg-panel",
        component: useStackRouteComponent(() => import("../pages/debug/debug.dialog.vue")),
        meta: {},
    },
    {
        parent: "public",
        path: "/debug/modificator/:modificatorId",
        component: useStackRouteComponent(() => import("../pages/debug/modificator-detail.dialog.vue")),
        meta: {},
    },
    {
        parent: "public",
        path: "/debug/feature/:featureId",
        component: useStackRouteComponent(() => import("../pages/debug/feature-detail.dialog.vue")),
        meta: {},
    },

    {
        parent: "public",
        path: "/debug/fortune-prize/:prizeId",
        component: useStackRouteComponent(() => import("../pages/debug/fortune-prize-detail.dialog.vue")),
        meta: {},
    },
    {
        parent: "public",
        path: "/debug/basket-rule/:ruleId",
        component: useStackRouteComponent(() => import("../pages/debug/basket-rule-detail.dialog.vue")),
        meta: {},
    },
    {
        parent: "public",
        path: "/delivery-service",
        component: useStackRouteComponent(() => import("@/pages/shop/vorder/delivery-select.dialog.vue"),),
        meta: {},
    },
]);

app.addRoutes([
    {
        parent: "personal",
        path: "/personal/dashboard",
        component: () => import("../pages/personal/dashboard.vue"),
        meta: {
            title: "Личный кабинет",
            hideMobileMenu: true,
        },
    },
    {
        parent: "personal",
        path: "/personal/orders",
        component: () => import("@/pages/shop/personal/order/orders.layout.vue"),
        meta: {
            title: "Заказы",
            breadcrumb: {},
            hideMobileMenu: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/shop/personal/order/orders.vue"),
                meta: {
                    title: "Заказы",
                    hideMobileMenu: true,
                },
            },
            {
                path: "/personal/orders/active",
                component: () => import("@/pages/shop/personal/order/orders-active.page.vue"),
                meta: {
                    title: "Активные заказы",
                    hideMobileMenu: true,
                },
            },
            {
                path: "/personal/orders/history",
                component: () => import("@/pages/shop/personal/order/orders-history.page.vue"),
                meta: {
                    title: "История заказов",
                    hideMobileMenu: true,
                },
            },
            {
                path: "/personal/order/:id/cancel",
                component: useStackRouteComponent(() => import("@/pages/shop/personal/order/dialog/order-cancel.dialog.vue")),
                meta: {
                    title: "Отменить заказ",
                    hideMobileMenu: true,
                },
            },
            {
                path: "/personal/order/:id/pay",
                component: useStackRouteComponent(() => import("@/pages/shop/personal/order/dialog/order-pay.dialog.vue")),
                meta: {
                    title: "Оплатить заказ",
                    hideMobileMenu: true,
                },
            },
        ],
    },
    {
        parent: "personal",
        path: "/personal/profile",
        component: useStackRouteComponent(() => import('../pages/personal/profile.dialog.vue')),
        meta: {
            hideMobileMenu: true,
        },
    },
    {
        parent: "personal",
        path: "/personal/profile-edit",
        component: useStackRouteComponent(() => import('../pages/personal/profile.dialog/dialogs/profile-edit.dialog.vue')),
        meta: {
            hideMobileMenu: true,
        },
    },
    {
        parent: "personal",
        path: "/personal/benefits",
        component: useStackRouteComponent(() => import('../pages/personal/benefits.dialog.vue')),
        meta: {
            hideMobileMenu: true,
        },
    },
    {
        name: 'user:logout',
        parent: "personal",
        path: "/personal/logout",
        component: useStackRouteComponent(() => import("../pages/personal/logout.dialog.vue")),
        meta: {
            hideMobileMenu: true,
        },
    },
]);
